export default __webpack_public_path__ + "7716c92.png";